module.exports = __webpack_public_path__ + "static/media/annexe_designation_clause_beneficiaire.cccdcebc.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/data/products/go/documents/adhesion/annexe_designation_clause_beneficiaire.pdf
// module id = 304
// module chunks = 40